import avatar from "../../../../../assets/img/demo/brandon-pena-avatar.png";

const row = {
    avatar: avatar,
    player: "Dustin Williamson",
    playing_position: "CF, RAMF, RWF",
    manager_agent: "Jonh Doe",
    country: "Brazil",
    team_club: "Liverpool",
    report_date: "31 Dec, 2019",
    selected: false,
};

const initialRows = Array.from(Array(32).keys())
    .map(i => JSON.parse(JSON.stringify([row, row, row, row, row][Math.floor((Math.random() * 5))]))).map((row, index) => {
        return Object.assign({}, {...row, id: index});
    });

export default initialRows;
